export const en = {
    marketOfficeLabel: 'Market - Office',
    marketOfficePlaceholder: 'Select a market/office',
    newClaimButton: 'Start a New Claim',
    newClaimButtonShort: 'New Claim',
    marketOfficeError: 'Please select a market and office.',
    phoneCallQuestion: 'If you have any questions or would prefer to report US-based damages by phone, please call:',
    openClaimsTitle: 'Open Claims',
    openClaimsClosureWarning: 'Open claims with no updates in 48 hours are subject to closure.',
    openClaimsTableDescription: 'A list of all the claims that have not yet been submitted to Phoenix Loss Control.',
    claimNumber: 'Claim Number',
    claimNumberShort: 'Claim #',
    lastUpdate: 'Last Update',
    dateReported: 'Date Reported',
    address: 'Address',
    client: 'Client',
    clientMarketOffice: 'Client / Market / Office',
    points: 'Points',
    status: 'Status',
    noOpenClaims: 'No Open Claims',
    completedClaimsTitle: 'Completed Claims',
    completedClaimsTableDescription: 'A list of all the claims that have been submitted to Phoenix Loss Control.',
    recovered: 'Recovered',
    comments: 'Comments',
    noCompletedClaims: 'No Completed Claims',
    hour: 'hour',
    hours: 'hours',
    dropdownOptions: {
        selectOption: 'Select an option',
        yes: 'Yes',
        no: 'No',
        na: 'N/A',
        naNoUnderground: 'NA - No Underground Damage',
        unknown: 'Unknown',
    },
    actions: {
        add: 'Add',
        remove: 'Remove',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
        save: 'Save',
        update: 'Update',
        confirm: 'Confirm',
        loading: 'Loading...',
        saving: 'Saving',
        continue: 'Continue',
        search: 'Search',
        close: 'Close',
    },
    damageDetailSummary: {
        header: 'Damage Details',
        damageDescription: 'Damage Description / General Commentary',
        subsAffected: 'Estimated # Of Subs Affected',
        outageDuration: 'Outage Duration',
        activityType: 'Activity Type',
        damageBy: 'Damage By',
        facilities: 'Facilities',
        wereLocatesPresent: 'Were Locates Present?',
        locateAccuracy: 'Locate Accuracy',
        locateMarkings: 'Locate Markings',
        spanReplacement: 'Was span replacement needed or was fiber damaged?',
        cableInConduit: 'Was u/g cable in conduit?',
        spanFootage: 'Span Footage Damaged/Replaced',
        otherMaterial: 'Cable Size / Fiber Count / Other Material',
    },
    damageDescription: {
        header: 'Damage Description',
        descriptionLabel: 'Damage Description / General Commentary',
        descriptionTooltip:
            'Enter details such as: What was damaged?\n' +
            'How was it damaged? Scope of work\n' +
            'being done when the damage occurred? Did you mark the damage? Do you have any comments on locate markings if they were present? If underground and not exposed,\n' +
            'how many feet is the damage from a particular landmark? Any police report numbers? Any other comments?',
        subsAffectedLabel: 'Estimated # of Subs Affected',
        subsAffectedTooltip: 'How many subscribers were affected by the damage?',
        outageDurationLabel: 'Outage Duration',
        outageDurationTooltip: 'How long were the affected customers out of service?',
        activityTypeLabel: 'Activity Type',
        activityTypeTooltip: 'What was the activity that caused the damage?',
        damageByLabel: 'Damage By',
        damageByTooltip: 'What caused the damage?',
    },
    damageLocation: {
        header: 'Damage Address',
        streetAddressLabel: 'Street Address',
        streetAddressTooltip:
            'What is the street address of the damage location? This is not to be confused by the affected customer address. If in a rural or new build area, what are the GPS coordinates?',
        crossStreetLabel: 'Cross Street',
        crossStreetTooltip: 'What is the closest cross street to the damage address or intersection?',
        cityLabel: 'City',
        cityTooltip: 'In what city did the damage occur?',
        stateLabel: 'State',
        statePlaceholder: 'Select a state',
        stateTooltip: 'In what state did the damage occur?',
        provinceLabel: 'Province',
        provincePlaceholder: 'Select a province',
        provinceTooltip: 'In what province did the damage occur?',
        zipCodeLabel: 'Zip Code',
        zipCodeTooltip: 'What is the damage location’s postal zip code?',
    },
    aerialDamage: {
        wasAerialLabel: 'Were above ground facilities damaged?',
        wasAerialTooltip: 'Did any of the damage occur above ground?',
        facilityNumberLabel: 'Ped / Pole / Amp',
        facilityNumberTooltip:
            'Does the pedestal, or AMP damaged have a number/name assigned? Does the pole have a number attached?',
    },
    damageType: {
        header: 'Damage Type',
        locationLabel: 'Location',
        locationTooltip:
            'What is the location type? For example, did the damage occur in the right of way, under roadway, etc.?',
    },
    internalIdentifications: {
        header: 'Internal Identifications',
        hubLabel: 'Hub',
        hubTooltip: 'What hub/lead-in do you use?',
        nodeLabel: 'Node',
        nodeTooltip: 'What nodes are affected by this damage?',
        nodeCheckboxLabel: 'Node unknown',
        outageIdLabel: 'Outage ID',
        outageIdTooltip: 'What is the outage, job, or work order number associated with this damage?',
    },
    times: {
        header: 'Dates & Times',
        damageDateLabel: 'Damage Date',
        damageDateTooltip: 'The date and time that the damage occurred.',
        damageDateError: 'The damage date cannot be after the discovery date.',
        damageTimeLabel: 'Damage Time',
        damageDateUnknownCheckbox: 'Damage date is unknown',
        discoveryDateLabel: 'Discovery Date',
        discoveryDateTooltip: 'The date and time that the damage was discovered.',
        discoveryDateError: 'The discovery date cannot be before the damage date.',
        discoveryTimeLabel: 'Discovery Time',
        discoveryDateSameCheckbox: 'Discovery date is the same as the damage date',
    },
    undergroundDamage: {
        wasUndergroundLabel: 'Were underground facilities damaged?',
        wasUndergroundTooltip: 'Did any of the damage occur below ground?',
        depthOfDamageLabel: 'Depth of Damage',
        depthOfDamageTooltip: 'How far down was the cable buried at the damage site?',
    },
    facilities: {
        header: 'Facilities',
        label: 'Facilities',
        placeholder: 'Select all that apply',
        tooltip: 'What type of facilities were damaged?',
    },
    locateMarkings: {
        label: 'Locate Markings',
        tooltip: 'How was the locate marked?',
        flagsLabel: 'Flags',
        flagsAriaLabel: 'Marking flags',
        paintLabel: 'Paint',
        paintAriaLabel: 'Marking paints',
        stakesLabel: 'Stakes',
        stakesAriaLabel: 'Marking stakes',
        unknownLabel: 'Unknown',
        unknownAriaLabel: 'Marking unknown',
    },
    locates: {
        header: 'Locates',
        wereLocatesPresentLabel: 'Were Locates Present?',
        wereLocatesPresentTooltip: 'Were locates present at the damage location?',
        locateAccuracyLabel: 'Locate Accuracy',
        locateAccuracyTooltip: 'Note if locates were visible and accurate or not.',
    },
    spanReplacement: {
        header: 'Span Replacement',
        wasSpanReplacementNeededLabel: 'Was span replacement needed OR was fiber damaged?',
        wasSpanReplacementNeededTooltip:
            'Was a replacement of some length of cable/fiber done on site or will one be required in the future (if a temporary repair was done)?',
        wasCableInConduitLabel: 'Was u/g cable in conduit?',
        wasCableInConduitTooltip: 'Was the cable housed in a conduit?',
        spanFootageLabel: 'Span Footage Damaged/Replaced',
        spanFootageTooltip: 'How long is the span that was damaged/replaced?',
        cableSizeLabel: 'Cable Size / Fiber Count / Other Material',
        cableSizeTooltip:
            'What size is the cable or other materials? (pedestal, power supply, 288 ct. fiber, .750, .500, etc.)',
        spanFootageUnknownCheckbox: 'Span footage replaced unknown',
        cableSizeUnknownCheckbox: 'Cable size, fiber count, other material unknown',
    },
    damagerKnown: {
        header: 'Damager Known',
        isDamagerKnownLabel: 'Do you know who the damager was?',
        isDamagerKnownTooltip: 'At this time, is the damager known or unknown?',
        damagerNameLabel: 'Damager Name',
        damagerNameTooltip: 'What is the name/company name of the suspected damager?',
        damagerIdentifiedLabel: 'How was the damager identified?',
        damagerIdentifiedTooltip: 'How did you identify the suspected damager?',
        isDamagerContactDetailsKnownLabel: 'Do you have contact details or a statement from the damager?',
        isDamagerContactDetailsKnownTooltip:
            'Is any contact information for the damager known? Do you have a statement from the damager?',
        damagerContactNameLabel: 'Damager Contact Name',
        damagerContactNameTooltip:
            'If known, who is the point of contact for the company? – e.g., foreman, superintendent, general manager, owner, etc.',
        damagerPhoneNumberLabel: 'Damager Phone Number',
        damagerPhoneNumberTooltip: 'What is a phone number the damagers can be reached at?',
        damagerEmailAddressLabel: 'Damager Email Address',
        damagerEmailAddressTooltip: 'What is an email address the damager can be reached at?',
        damagerStatementLabel: 'Damager Statement',
        damagerStatementTooltip: 'Did the damager make any remarks about the damage?',
    },
    damagerOpinion: {
        header: 'Damager Opinion',
        hasOpinionLabel: 'Do you have an opinion on who was responsible for the damage?',
        hasOpinionTooltip: 'Do you think you know who may have been responsible for the damage?',
        responsiblePartyLabel: 'Who was responsible for the damage?',
        responsiblePartyTooltip: 'Who do you think is responsible for the damage?',
    },
    futureRepairs: {
        header: 'Future Repairs',
        areFutureRepairsNeededLabel: 'Is a future span replacement or any other repairs needed?',
        areFutureRepairsNeededTooltip: 'Will future repairs be needed at the damage location?',
        clientConstructionNumberLabel: 'Client Construction #',
        clientConstructionNumberTooltip: 'Your company’s construction tracking number, if available.',
        clientConstructionNumberUnknownCheckbox: 'Client construction number unknown',
        constructionCoordinatorLabel: 'Construction Coordinator',
        constructionCoordinatorTooltip: 'The construction coordinator for the claim.',
        constructionCoordinatorEmailLabel: 'Construction Coordinator Email Address',
        constructionCoordinatorEmailTooltip: 'Email address for the construction coordinator',
        constructionCoordinatorPhoneLabel: 'Construction Coordinator Phone Number',
        constructionCoordinatorPhoneTooltip: 'Phone number for the construction coordinator',
        createNewCoordinatorOption: 'Create a new construction coordinator - "{searchText}"',
    },
    laborDetails: {
        personnelHeader: 'Personnel',
        materialsHeader: 'Materials',
        vehiclesHeader: 'Vehicles',
    },
    materials: {
        materialTypeLabel: 'Material Type',
        materialTypeTooltip:
            'What materials did you use to make the repair? e.g., 200’ of RG11 cable, 2 RG11 connectors, 2 Pin-Fs',
        materialTypePlaceholder: 'Start typing to see material types...',
        quantityLabel: 'Length / Quantity',
        quantityTooltip: 'The total amount of the material used.',
        confirmDeleteTitle: 'Confirm Delete',
        confirmDeleteMessage: 'Are you sure you want to delete this material?',
    },
    materialTable: {
        nameHeader: 'Name',
        quantityHeader: 'Quantity',
        emptyMessage: 'No Materials Added',
    },
    personnel: {
        personnelTypeLabel: 'Personnel Type',
        personnelTypeTooltip:
            'How many persons worked this repair? e.g., 10/18/21 Paul Jones, OSP Tech, 1-hour regular time and 2 hours on overtime.',
        personnelTypePlaceholder: 'Start typing to see personnel types...',
        regularTimeLabel: 'Time',
        regularTimeTooltip: 'How many non-overtime hours did the technician(s) work?',
        overtimeLabel: 'Overtime',
        overtimeTooltip: 'How many overtime hours did the technician(s) work?',
        confirmDeleteTitle: 'Confirm Delete',
        confirmDeleteMessage: 'Are you sure you want to delete this personnel?',
    },
    personnelTable: {
        positionHeader: 'Position',
        timeHeader: 'Time',
        overtimeHeader: 'Overtime',
        emptyMessage: 'No Personnel Added',
    },
    repairs: {
        header: 'Repairs',
        repairsDoneOnSiteLabel: 'Have onsite repairs been started/completed?',
        repairsDoneOnSiteTooltip: 'Have onsite repairs been started/completed, or do you have labor to report?',
        referenceLabel: 'Reference / Construction Job / Other Internal Job Reference #',
        referenceTooltip:
            'If there is any other internal company\n' +
            'reference number associated with this damage, such as a job number for the construction department\n' +
            'to do a span replacement, enter it here.',
    },
    vehicles: {
        vehicleTypeLabel: 'Vehicle Type',
        vehicleTypeTooltip: 'What vehicles were used when the repairs were completed?',
        vehicleTypePlaceholder: 'Start typing to see vehicle types...',
        regularTimeLabel: 'Time',
        regularTimeTooltip: 'How many hours was the vehicle used?',
        confirmDeleteTitle: 'Confirm Delete',
        confirmDeleteMessage: 'Are you sure you want to delete this vehicle?',
    },
    vehicleTable: {
        vehicleTypeHeader: 'Vehicle Type',
        timeHeader: 'Time',
        emptyMessage: 'No Vehicles Added',
    },
    damageDetailsSummary: {
        stepLink: 'Damage Details',
        damageDescriptionLabel: 'Damage Description / General Commentary',
        estimatedSubsAffectedLabel: 'Estimated # Of Subs Affected',
        outageDurationLabel: 'Outage Duration',
        activityTypeLabel: 'Activity Type',
        damageByLabel: 'Damage By',
        facilitiesLabel: 'Facilities',
        wereLocatesPresentLabel: 'Were Locates Present?',
        locateAccuracyLabel: 'Locate Accuracy',
        locateMarkingsLabel: 'Locate Markings',
        spanReplacementNeededLabel: 'Was span replacement needed or was fiber damaged?',
        cableInConduitLabel: 'Was u/g cable in conduit?',
        spanFootageLabel: 'Span Footage Damaged/Replaced',
        cableSizeLabel: 'Cable Size / Fiber Count / Other Material',
    },
    damagerDetailsSummary: {
        stepLink: 'Damager Details',
        opinionLabel: 'Do you have an opinion on who was responsible for the damage?',
        responsiblePartyLabel: 'Who was responsible for the damage?',
        isDamagerKnownLabel: 'Do you know who the damager was?',
        damagerNameLabel: 'Damager Name',
        howWasDamagerIdentifiedLabel: 'How was the damager identified?',
        haveDamagerDetailsLabel: 'Do you have contact details or a statement from the damager?',
        damagerContactNameLabel: 'Damager Contact Name',
        damagerPhoneNumberLabel: 'Damager Phone Number',
        damagerEmailAddressLabel: 'Damager Email Address',
        damagerStatementLabel: 'Damager Statement',
    },
    locationDetailsSummary: {
        stepLink: 'Location Details',
        damageDateLabel: 'Damage Date',
        damageTimeLabel: 'Damage Time',
        discoveryDateLabel: 'Discovery Date',
        discoveryTimeLabel: 'Discovery Time',
        streetAddressLabel: 'Street Address',
        crossStreetLabel: 'Cross Street',
        cityLabel: 'City',
        stateLabel: 'State',
        zipCodeLabel: 'Zip Code',
        locationTypeLabel: 'Location Type',
        aboveGroundFacilitiesLabel: 'Were above ground facilities damaged?',
        pedPoleAmpLabel: 'Ped - Pole - Amp',
        undergroundFacilitiesLabel: 'Were underground facilities damaged?',
        depthOfDamageLabel: 'Depth of damage',
        hubLabel: 'Hub',
        nodeLabel: 'Node',
        outageIdLabel: 'Outage Id',
    },
    materialSummary: {
        stepLink: 'Materials',
        noMaterialsMessage: 'No materials were added to this claim.',
        nameHeader: 'Name',
        quantityHeader: 'Length / Quantity',
    },
    personnelSummary: {
        stepLink: 'Personnel',
        noPersonnelMessage: 'No personnel were added to this claim.',
        titleHeader: 'Title',
        regularHeader: 'Regular',
        overtimeHeader: 'Overtime',
        regularTimeHeader: 'Regular Time',
    },
    photosAndDocumentsSummary: {
        stepLink: 'Photos & Documents',
        noFilesMessage: 'No files were added to this claim.',
    },
    repairDetailsSummary: {
        stepLink: 'Repair Details',
        repairsDoneOnSiteLabel: 'Have onsite repairs been started/completed?',
        referenceLabel: 'Reference / Construction Job / Other Internal Job Reference #',
        futureRepairsNeededLabel: 'Are future repairs needed?',
        constructionCoordinatorNameLabel: 'Construction Coordinator Name',
        constructionCoordinatorEmailLabel: 'Construction Coordinator Email',
        constructionCoordinatorPhoneLabel: 'Construction Coordinator Phone',
        additionalCommentsLabel: 'Additional Repair Comments',
        repairDetailsLabel: 'Repair Details',
    },
    vehicleSummary: {
        stepLink: 'Vehicles',
        noVehiclesMessage: 'No vehicles were added to this claim.',
        nameHeader: 'Name',
        regularTimeHeader: 'Regular Time',
    },
    uploadedFiles: {
        removingBusyText: 'Removing',
        confirmRemoveTitle: 'Confirm Remove',
        confirmRemoveMessage: 'Are you sure you want to remove "{fileName}"?',
    },
    buttonBar: {
        exitButton: 'Exit',
        saveAndQuitButton: 'Save & Quit',
        previousButton: 'Previous',
        nextButton: 'Next',
        completeButton: 'Complete',
        confirmSubmitTitle: 'Confirm Submit',
        confirmSubmitMessage: 'Are you sure you want to submit this claim?',
        confirmSaveAndQuitTitle: 'Confirm Save & Quit',
        confirmSaveAndQuitMessage: 'Are you sure you want to save this claim and return to the dashboard?',
        confirmCancelTitle: 'Return to Dashboard?',
        confirmCancelMessage: 'Are you sure you want to return to the dashboard?',
    },
    repairDetails: {
        freeFormQuestion:
            'Would you like to enter repair details as free text, or would you like to use drop downs to choose specific labor, materials, and vehicle types?',
        freeFormTooltip: 'How would you like to enter repairs details?',
        freeFormNoText: 'Text',
        freeFormYesText: 'Fields',
        repairDetailsWarning:
            'Please provide details for onsite repairs. Please include notes, if applicable, on what personnel were onsite and for how long (e.g. two fiber techs for 2 hours), what materials and in what quantities they were used (e.g. 100 ft of Rg-11 cable), and what vehicles were onsite and for how long (e.g. one bucket truck for two hours).',
        repairDetailsLabel: 'Repair Details',
        repairDetailsTooltip: 'Enter repair details.',
        additionalCommentsLabel: 'Additional Repair Comments',
        additionalCommentsTooltip: 'Do you have anything else to add about the repairs?',
    },
    summaryDetails: {
        additionalCommentsLabel: 'Additional Comments',
        additionalCommentsTooltip: 'Do you have any additional comments about the claim?',
    },
    uploadPhotosAndDocs: {
        header: 'Upload Photos & Documents',
        fileUploadTitle: 'File Upload',
        fileDescriptionTitle: 'File Description',
        fileNameLabel: 'File Name:',
        fileDescriptionLabel: 'File Description:',
        description: 'Description',
        errorUploadingMessage: 'Error uploading. Please try again.',
        successUploadingMessage: 'File(s) Uploaded Successfully!',
        successRemovingMessage: 'File Removed Successfully!',
        duplicateFilesMessage: 'The following file(s) have already been uploaded:',
        removeDuplicatesMessage: 'Please remove them before uploading again.',
    },
    claimWizard: {
        requiredFieldWarning1: 'Fields marked with a ',
        requiredFieldWarning2: ' are required.',
        steps: {
            locationDetails: 'Location Details',
            photosAndDocs: 'Photos & Docs',
            damageDetails: 'Damage Details',
            damagerDetails: 'Damager Details',
            repairDetails: 'Repair Details',
            summaryDetails: 'Summary Details',
            locationShort: 'Location',
            uploadShort: 'Upload',
            damageShort: 'Damage',
            damagerShort: 'Damager',
            repairShort: 'Repair',
            summaryShort: 'Summary',
        },
        cmoPlaceholder: '{clientName} / {marketName} / {officeName}',
    },
    fileUpload: {
        command: 'Choose file(s) or drag them here',
        sizeRestrictionLine1: 'You may upload multiple files but the total size should not exceed 50MB.',
        sizeRestrictionLine2: 'If you have more than 50MB, please upload in batches.',
        uploading: 'Uploading...',
    },
    resources: 'Resources',
    technician: {
        header: 'Technician',
        firstName: 'First Name',
        lastName: 'Last Name',
        phoneNumber: 'Phone Number',
        emailAddress: 'Email Address',
        supervisorEmailAddress: 'Supervisor Email Address',
        username: 'Username',
        usernameSpaced: 'User Name',
        uniqueEmailError: 'An account with this email address already exists.',
        usernameTooltip:
            'The unique tech username that was chosen when the account was created. This cannot be changed.',
        firstNameTooltip: 'The first name of the technician.',
        lastNameTooltip: 'The last name of the technician.',
        phoneNumberTooltip: 'A phone number that the technician can be reached at.',
        emailAddressTooltip: 'An email address that the technician can be reached at.',
    },
    supervisor: {
        header: 'Supervisor',
        firstName: 'First Name',
        lastName: 'Last Name',
        phoneNumber: 'Phone Number',
        emailAddress: 'Email Address',
        firstNameTooltip: "The first name of the technician's supervisor.",
        lastNameTooltip: "The last name of the technician's supervisor.",
        phoneNumberTooltip: "A phone number that the technician's supervisor can be reached at.",
        emailAddressTooltip: "An email address that the technician's supervisor can be reached at.",
    },
    cmoSelection: {
        header: 'Markets & Offices',
        markets: 'Markets',
        offices: 'Offices',
        selectMarket: 'Select a market.',
        selectOffice: 'Select an office.',
        removalMessage: 'Are you sure you want to remove this market/office?',
        removalTitle: 'Confirm Removal',
    },
    menuOptions: {
        signedInAs: 'Signed in as',
        signOut: 'Sign Out',
        confirmSignOut: 'Are you sure you want to sign out?',
        signIn: 'Sign In',
        register: 'Register',
        dashboard: 'Dashboard',
        dashboardReturnMessage: 'Are you sure you want to return to the dashboard?',
        dashboardReturnTitle: 'Return to Dashboard?',
        updateContactInfo: 'Update Contact Info',
        darkMode: 'Change to Dark Mode',
        lightMode: 'Change to Light Mode',
    },
    mainMenu: {
        landingMessage: 'Please sign in or register a new account',
    },
    registration: {
        workEmailAddress: 'Work Email Address',
        workEmailAddressTooltip: 'What is your work email address?',
        possibleClients: 'Possible Clients',
        possibleClientsTooltip: 'Please select the correct client or the not found option.',
        notFound: 'Not Found',
        workEmailAddressInstructions:
            'Please enter your work email address below so that we can attempt to match you to a client.',
        registerTextExistingLogin: 'Registering an existing login!',
        registerTextExistingTech: 'Registering an existing reporting tech!',
        accountAlreadyExists: 'An account with this email address already exists.',
        allClients: 'All Clients',
        allClientsTooltip: 'Please select the client you work for.',
        existingClient: 'Existing Client',
        existingClientTooltip: 'The client that you work for was identified by your previous claims.',
        registerAccountHeader: 'Register Account',
        userNameTaken: 'The username is already taken.',
        technicianDetailsHeader: 'Technician Details',
        supervisorDetailsHeader: 'Supervisor Details',
        firstNameTooltip: 'The technicians first name.',
        lastNameTooltip: 'The technicians last name.',
        usernameTooltip: 'The unique username for the account.',
        phoneNumberTooltip: 'A phone number for the technician.',
        emailAddressTooltip: 'An email address for the technician.',

        supervisorFirstNameTooltip: 'The supervisors first name.',
        supervisorLastNameTooltip: 'The supervisors last name.',
        supervisorPhoneNumberTooltip: 'A phone number for the supervisor.',
        supervisorEmailAddress: 'Supervisor Email Address',
        supervisorEmailAddressTooltip: 'An email address for the technicians supervisor.',

        confirmEmailAddress: 'Confirm Email Address',
        confirmEmailAddressTooltip: 'Confirm the email address for the technician.',
        password: 'Password',
        passwordTooltip:
            'A password for the technician. Must be at least 8 characters. Must contain at least one capital letter, one lowercase letter, one number and one special character.',
        confirmPassword: 'Confirm Password',
        confirmPasswordTooltip: 'Confirm the password for the technician.',
        passwordWarning:
            'Password must be at least 8 characters and contain at least one capital letter, one lowercase letter, one number, and one special character.',
        selectMarketOfficeError: 'You must select at least one market/office combination.',
        selectMarketTooltip: 'Select a market to see the offices',
        selectMarketPlaceholder: 'Add a market',
        selectOfficeTooltip: 'Select the office you want to be able to submit claims for',
        selectOfficePlaceholder: 'Add an office',

        changeEmailMessage:
            'Please reenter your password or create a new one. You will be signed out and will need to sign in again with your updated login information.',
    },
    signInModal: {
        title: 'Sign In Required',
        message: 'Your login info has changed. You will be redirected to sign in again.',
    },
    crashScreen: {
        title: 'Oh no! Something went wrong!',
        line1: 'If you continue to have difficulty logging in, please reach out to',
        byPhone: ' by phone at',
        byEmail: ' or by email at',
        returnToLoginScreen: 'Return to login screen',
    },
    updateContactInfo: {
        title: 'Update Contact Info',
        subtitle: 'Please keep this information up to date',
        close: 'Close update contact info panel',
        confirmationMessage: 'Are you sure you want to update the contact info?',
        confirmationTitle: 'Confirm Update',
    },
    profile: {
        confirmMessage: 'Please confirm that we have the correct profile information.',
        confirmButton: 'Confirm',
        confirmUpdateMessage: 'Are you sure you want to update the contact info?',
        confirmUpdateTitle: 'Confirm Update',
        updateSuccess: 'Profile Information Updated Successfully!',
    },
    validation: {
        emailRequired: 'An email address is required.',
        emailInvalid: 'A valid email address is required.',
        firstNameRequired: 'A first name is required.',
        lastNameRequired: 'A last name is required.',
        phoneRequired: 'A phone number is required.',
        phoneInvalid: 'A valid phone number is required.',
        passwordsDoNotMatch: 'The passwords do not match.',
        confirmPasswordRequired: 'A confirm password is required.',
        passwordRequired: 'A valid password is required.',
        passwordInvalid: 'Password does not match the required format.',
        supervisorEmailRequired: 'An email address is required.',
        supervisorEmailInvalid: 'A valid email address is required.',
        supervisorFirstNameRequired: 'A first name is required.',
        supervisorLastNameRequired: 'A last name is required.',
        supervisorPhoneRequired: 'A phone number is required.',
        supervisorPhoneInvalid: 'A valid phone number is required.',
        confirmEmailRequired: 'A confirm email address is required.',
        emailMismatch: 'Email address does not match.',
        userNameRequired: 'A user name is required.',
        isRequired: 'is required.',
        defaultRequired: 'An answer is required.',
        invalidZipCode: 'Invalid zip code.',
    },
    locateAccuracies: {
        49: 'Locates appear accurate',
        50: 'Locates appear off/in wrong area',
        51: 'Locate marks faded/not visible',
        52: 'Locates present but not for our damaged facilities',
        53: 'Unknown',
        54: 'Locate Ticket Invalid',
    },
    damageActivityTypes: {
        1: 'Aerial Tear Down',
        2: 'Cable Theft',
        6: 'Fire',
        10: 'Irrigation',
        11: 'Landscaping',
        12: 'Motor Vehicle',
        17: 'Roofing',
        22: 'Train',
        25: 'Tree Trimming',
        26: 'Cable TV',
        27: 'Storm Drain/Culvert',
        28: 'Fencing',
        29: 'Natural Gas',
        30: 'Unknown/Other',
        31: 'Sewer',
        32: 'Traffic Sign',
        33: 'Road Work',
        34: 'Telecommunications',
        35: 'Water',
        36: 'Agriculture',
        37: 'Curb/Sidewalk',
        38: 'Bldg. Construction',
        39: 'Bldg. Demolition',
        40: 'Driveway',
        41: 'Electric',
        42: 'Engineering/Surveying',
        43: 'Grading',
        44: 'Liquid Pipeline',
        45: 'Milling',
        46: 'Pole',
        47: 'Public Transit Authority',
        48: 'Railroad',
        49: 'Drainage',
        50: 'Site Development',
        51: 'Steam',
        52: 'Street Light',
        53: 'Traffic Signal',
        54: 'Waterway Improvement',
    },
    damageByTypes: {
        1: 'Crane',
        3: 'Dump Truck',
        5: 'Boring',
        7: 'Cable Theft',
        8: 'Auger',
        11: 'Farm Equipment',
        13: 'Motor Vehicle',
        16: 'Roofers',
        18: 'Tractor',
        19: 'Train',
        20: 'Trencher',
        23: 'Chainsaw',
        24: 'Snow Plow',
        25: 'Tree Trimmer',
        26: 'Garbage Truck',
        29: 'Backhoe/Trackhoe',
        30: 'Bulldozer',
        33: 'Grader/Scraper',
        35: 'Unknown/Other',
        36: 'Hand Tools',
        37: 'Drilling',
        38: 'Directional Drilling',
        39: 'Explosives',
        40: 'Milling Equipment',
        41: 'Probing Device',
        42: 'Vacuum Equipment',
    },
    damageFacilityTypes: {
        1: 'Aerial Cable',
        2: 'Buried Fiber',
        3: 'Pole',
        4: 'Utility Vault',
        5: 'New Facility',
        6: 'Inside Facilities',
        7: 'Aerial Service',
        8: 'Buried Cable',
        9: 'Drop Service',
        10: 'Pedestal/Enclosure/AP Box',
        11: 'Aerial Fiber',
        14: 'Housing / Housing Coupler / DC9 / Splitter',
        15: 'Company Vehicle',
        16: 'Conduit/Duct Line',
        17: 'No Cable Damage',
        18: 'Power Supply',
        19: 'Temp Line',
        20: 'Distribution',
        21: 'Gathering',
        22: 'Transmission',
        23: 'Streetlight',
        24: 'Fence/Gate',
        25: 'Building',
        26: 'Transmission Tower',
        27: 'Transformer',
        28: 'Meter',
        29: 'Restitution',
        30: 'Anchor Guy',
    },
    damageLocationTypes: {
        12: 'Cable Theft',
        18: 'Private - Land Owner',
        19: 'Public - Other',
        20: 'Private - Business',
        22: 'Unknown/Other',
        23: 'Dedicated Public Utility Easement',
        24: 'Public - City Street',
        25: 'Public - State Highway',
        26: 'Public - County Road',
        27: 'Public - Interstate Highway',
        28: 'Private Easement',
        29: 'Pipeline',
        30: 'Power/Transmission Line',
        31: 'Railroad',
        32: 'Federal Land',
    },
    adversePartyTypes: {
        1: 'Damager',
        2: 'Locate Company',
        4: 'Other',
        5: 'Unknown',
    },
};
